/* Pool-badge — toont in welke talentpool een kandidaat zit.
 * cronos → amber (interne bench) · external → neutraal · custom pools → blauw. */
import React from "react";
import i18n from "i18next";

const STYLE = {
    cronos: "bg-[var(--jr-amber)]/20 text-[var(--jr-amber)] border-[var(--jr-amber)]/30",
    external: "bg-white/5 text-[var(--jr-text-3)] border-white/10",
    custom: "bg-[var(--jr-info)]/15 text-[var(--jr-info)] border-[var(--jr-info)]/30",
};

export function PoolBadge({ poolKey, poolName, testid }) {
    const key = poolKey || "external";
    const cls = STYLE[key] || STYLE.custom;
    const name = poolName || (key === "cronos" ? "Cronos" : key === "external" ? i18n.t("search.pool_external") : key);
    return (
        <span data-testid={testid}
            title={i18n.t("search.in_pool_tip", { pool: name })}
            className={`text-[9px] font-mono uppercase tracking-[0.16em] px-1.5 py-0.5 rounded border ${cls}`}>
            {name}
        </span>
    );
}
